/**
 * Travel 扁平文案表查詢：依 locale 取表，未知語系回退 en_US（與共用 translate 一致）；缺 key 回傳 key。
 */
export function createFlatMessageLookup(byLocale) {
  return function lookup(locale, key) {
    const normalized = String(locale || '').replace('-', '_');
    const table = byLocale[normalized] || (normalized === 'zh_HK' ? byLocale.zh_TW : null) || byLocale.en_US;
    const message = table?.[key];
    return typeof message === 'string' ? message : key;
  };
}
